import React from 'react';
import { Link } from 'gatsby';

import { Image, Button, ButtonColors } from '@/components/general';
import { Links } from '@/utils/constants';
import { RemoveSpaces } from '@/utils/functions';
import { Tag, TagAttachment, TagVariants } from '../Tag';

import * as styled from './TemplateCard.styled';

interface ITemplateCard {
  template: any;
  isTemplateSlug?: boolean;
}

export const TemplateCard: React.FC<ITemplateCard> = ({
  template,
  isTemplateSlug,
}) => {
  const {
    mainIcon,
    additionalIcon,
    title,
    categories,
    technologies,
    languages,
    description,
    studioImage,
    studioTemplateId,
    // previewUrl,
  } = template;

  const languagesTags = languages.map((el: string) => ({
    attachment: TagAttachment.LANGUAGES,
    tag: el,
  }));

  const tags = [
    {
      attachment: TagAttachment.CATEGORIES,
      tag: categories[0],
    },
    {
      attachment: TagAttachment.TECHNOLOGIES,
      tag: technologies[0],
    },
  ]
    .concat(languagesTags)
    .filter((tag) => tag.tag !== undefined);

  const isBrowser = () => typeof window !== 'undefined';

  return (
    <styled.Container>
      <styled.TemplateBox>
        <styled.IconBox>
          <Image src={mainIcon.url} />
          {additionalIcon && (
            <>
              <styled.PlusBox>
                <span />
                <span />
              </styled.PlusBox>
              <Image src={additionalIcon.url} />
            </>
          )}
        </styled.IconBox>
        <styled.TitleBox>
          {!isTemplateSlug ? (
            <Link to={`/templates/${RemoveSpaces(title)}`}>
              <styled.Title>{title}</styled.Title>
            </Link>
          ) : (
            <styled.Title>{title}</styled.Title>
          )}
        </styled.TitleBox>
        <styled.TagsBox>
          {tags?.map((tag) => (
            <Tag
              key={tag.tag}
              variant={TagVariants.SMALL}
              attachment={tag.attachment}
            >
              {tag.tag}
            </Tag>
          ))}
        </styled.TagsBox>
        <styled.DescriptionBox>
          <styled.Description>{description.description}</styled.Description>
        </styled.DescriptionBox>
        <styled.ButtonBox>
          {!!studioTemplateId &&
            process.env.GATSBY_SHOW_CLONE_BUTTON === 'true' && (
              <Button
                to={`https://dev.app.codeplatform.com/templates/${studioTemplateId}`}
                blank
              >
                {isBrowser() && window.innerWidth < 440
                  ? 'Start building'
                  : 'Clone and start building'}
              </Button>
            )}
          <styled.SmallButtonBox>
            {/* {previewUrl && (
              <Button to={previewUrl} blank color={ButtonColors.SECONDARY}>
                Preview
              </Button>
            )} */}
            {isTemplateSlug && (
              <Button to={Links.TALK} color={ButtonColors.SECONDARY}>
                Talk to experts
              </Button>
            )}
            {!isTemplateSlug && (
              <Button
                to={`/templates/${RemoveSpaces(title)}`}
                color={ButtonColors.SECONDARY}
              >
                Learn more
              </Button>
            )}
          </styled.SmallButtonBox>
        </styled.ButtonBox>
      </styled.TemplateBox>
      <styled.ImageBox>
        <styled.ImageBorderBox>
          <Image src={studioImage.url} />
        </styled.ImageBorderBox>
      </styled.ImageBox>
    </styled.Container>
  );
};
